import React, { Fragment } from "react"
import clsx from "clsx"

import classes from "./TreeMultiSelectNode.module.scss"

const TreeMultiSelectNode = (props) => {
  const {
    tree,
    j = 0,
    onAdd,
    onRemove,
    setSearch,
    selectedNodes,
    setSelectedNodes,
    setResultTree
  } = props

  const handleSelect = (node) => {
    const isSelected =
      selectedNodes.some(selectedNode =>
        selectedNode._id === node._id
      )

    if (isSelected) return onRemove(node)

    const newSelectedNodes =
      [...selectedNodes, { ...node }].map(newSelectedNode => ({
        _id: newSelectedNode._id,
        name: newSelectedNode.name,
        node: newSelectedNode
      }))

    setSearch("")

    setResultTree(null)

    setSelectedNodes(newSelectedNodes)

    onAdd(node)
  }

  const isNodeSelected =
    selectedNodes.some(selectedNode =>
      selectedNode.name === tree.name
    )

  return (
    <Fragment>
      {
        !!tree.name &&
        <div className={classes["node-container"]}>
          <div
            onClick={() => handleSelect(tree)}
            style={{ marginInlineStart: `${(j - 1) * 10}px` }}
            className={clsx(
              classes["node"],
              isNodeSelected && classes["active"]
            )}
          >
            {tree.name}
          </div>
        </div>
      }

      {tree.children.map(child =>
        <TreeMultiSelectNode
          key={child._id}
          tree={child}
          j={j + 1}
          onAdd={onAdd}
          onRemove={onRemove}
          setSearch={setSearch}
          selectedNodes={selectedNodes}
          setSelectedNodes={setSelectedNodes}
          setResultTree={setResultTree}
        />
      )}
    </Fragment>
  )
}

export default TreeMultiSelectNode